import React from "react";
import { useState } from "react";
import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps";

import { IconButton, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import SearchIcon from "@mui/icons-material/SearchOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

import { features } from "./features";

import "./Maps.css";

export type MapsProps = {
  country?: string;
  onSelect: (countryId: string, countryName: string, code: string) => void;
};

const Maps = ({ country, onSelect }: MapsProps) => {
  const [selected, setSelected] = useState(country || "");
  const [zoom, setZoom] = useState(1);
  const [coordinates, setCoordinates] = useState<[number, number]>([0, 0]);

  const handleZoomIn = () => {
    zoom < 4 && setZoom(zoom + 0.3);
  };
  const handleZoomOut = () => {
    zoom >= 1.3 && setZoom(zoom - 0.3);
  };
  const handleZoomReset = () => {
    setZoom(1);
    setCoordinates([0, 0]);
  };
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Typography variant="h4" sx={{ ml: 1 }}>
          Country
        </Typography>
        <Box sx={{ display: "flex", gap: "6px" }}>
          <IconButton
            aria-label="Reset Zoom Button"
            color="primary"
            onClick={handleZoomReset}
            sx={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "1px solid var(--mui-palette-primary-light)",
            }}>
            <SearchIcon />
          </IconButton>
          <IconButton
            aria-label="Zoom In Button"
            color="primary"
            onClick={handleZoomIn}
            sx={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "1px solid var(--mui-palette-primary-light)",
            }}>
            <ZoomInIcon />
          </IconButton>
          <IconButton
            aria-label="Zoom Out Button"
            color="primary"
            onClick={handleZoomOut}
            sx={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "1px solid var(--mui-palette-primary-light)",
            }}>
            <ZoomOutIcon />
          </IconButton>
        </Box>
      </Box>
      <Stack alignItems="center">
        <ComposableMap style={{ width: "313px" }}>
          <ZoomableGroup
            onMoveEnd={({ coordinates, zoom }: any) => {
              setZoom(zoom);
              setCoordinates(coordinates);
            }}
            center={coordinates}
            zoom={zoom}>
            <Geographies geography={features}>
              {({ geographies }: any) =>
                geographies.map((geo: any) => (
                  <Geography
                    style={{
                      default: {
                        fill:
                          selected === geo.id
                            ? "var(--mui-palette-primary-main)"
                            : "rgba(38, 70, 83, 0.13)",
                      },
                      hover: {
                        fill: "var(--mui-palette-primary-main)",
                      },
                      pressed: {
                        fill: "var(--mui-palette-primary-main)",
                      },
                    }}
                    stroke="var(--mui-palette-primary-contrastText)"
                    onClick={() => {
                      setSelected(geo.id);
                      onSelect(geo.id, geo.properties.name, geo.properties?.code);
                    }}
                    key={geo.rsmKey}
                    geography={geo}
                  />
                ))
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>
      </Stack>
    </Box>
  );
};

export default Maps;
